import { __assign, __extends } from "tslib";
import * as React from 'react';
import omit from 'lodash/omit';
import classnames from 'classnames';
import Button from '../../../Button';
import SolidButton from '../../../Buttons/SolidButton';
import * as s from './FooterButton.scss';
var FooterButton = /** @class */ (function (_super) {
    __extends(FooterButton, _super);
    function FooterButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FooterButton.prototype.render = function () {
        var _a = this.props, view = _a.view, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
        return view === undefined ? (React.createElement(SolidButton
        // Take SolidButton doesn't have a height prop, so remove it
        , __assign({}, omit(this.props, ['height']), { variant: "branded-green", size: size, className: classnames(s['new-ds-footer-btn'], s[size], this.props.className) }))) : (React.createElement(Button, __assign({}, this.props, { height: this.props.height || size, className: classnames(s['footer-btn'], this.props.className) })));
    };
    return FooterButton;
}(React.Component));
export default FooterButton;
//# sourceMappingURL=FooterButton.js.map